import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Dialog, FormGroup, Input, RadioGroup } from '@tencent/spaui';
import { withApi } from '@tencent/react-aio';
import {
  leadStatusMap,
  REACT_APP_PUBLIC_URL,
  ACCOUNT_STATUS,
  DIAL_OUT_RESULT_TYPE,
} from '@/constants/Constants';
import perms from '@/common/permissions/sale/perms';
import { withAccount } from '@/business-components/operator/account-context';
import message from '@/utils/message';
import DateTime from '@/components/DateTime';
import { rendeFirstChargeAmt } from '@/utils/ColumnRender';
import classNames from 'classnames';
import { LeadsItem } from '@/model/leads';
import { PotentialsItem } from '@/model/potentials';
import Delegate from '@/components/Delegate';
import AccountDetail from '@/pages/orders/AccountDetail';
import { User } from '@/model/user';
import CustomerIdView from '@/business-components/sale/customers/CustomerIdView';
import { OrdersItem } from '@/model/orders';
import IndustryInfo from '@/business-components/sale/IndustryInfo';
import TipIcon from '@/common-components/tip-icon';
import { checkNumber } from './api';

const errConfig = {
  qqNumber: { tip: '请输入QQ号', field: 'qqNumberErr' },
  weiXinId: { tip: '请输入微信号', field: 'weiXinIdErr' },
  mobile: { tip: '请输入手机号', field: 'mobileErr' },
};

interface WhiteList {
  data: number[];
}
interface AccountPanelProps {
  webApi: {
    getLeadStatus: (leadId: number) => any; // 获取线索状态
    gdtOpen: () => any; // gdt开户
  };
  lead: LeadsItem;
  detail: LeadsItem | PotentialsItem | OrdersItem;
  account: User;
  registrationTicketId?: number; // 开户单id
  isOrder?: boolean; // 是否为订单
  callback: () => void; // 成功后cb
  whiteList: WhiteList;
  supportWx?: boolean; // 是否支持wx + 手机号 开户
}

interface AccountPanelState {
  linkUrl: string;
}

interface OpenAccountModalState {
  show: boolean;
  qqNumber: string | null;
  qqNumberErr: string;
  weiXinId: string | null;
  weiXinIdErr: string;
  mobile: string | null;
  mobileErr: string;
  radioValue: string;
}

const OPTIONS = [
  {
    value: 'qqNumber',
    label: 'QQ号开户',
  },
  {
    value: 'weiXinId',
    label: '微信开户',
  },
];

class OpenAccountModal extends React.PureComponent<
AccountPanelProps,
OpenAccountModalState
> {
  private disable: boolean;
  private timeout: number;
  constructor(props: AccountPanelProps) {
    super(props);
    this.state = {
      qqNumber: null,
      show: false,
      qqNumberErr: '',
      weiXinId: null,
      weiXinIdErr: '',
      mobile: null,
      mobileErr: '',
      radioValue: OPTIONS[0].value,
    };
  }

  renderAccountId = () => {
    return (
      <span className="customer-account-id">
        客户还未注册开通广点通账户，您可协助客户开户，点击{' '}
        <span onClick={this.handleOpen}>完成开户</span>
      </span>
    );
  };

  handleOpen = () => {
    this.setState({ show: true });
  };

  handleClose = () => {
    this.setState({
      show: false,
      qqNumberErr: '',
      qqNumber: null,
    });
  };

  handleNewClose = () => {
    this.setState({
      show: false,
      qqNumberErr: '',
      qqNumber: null,
      weiXinId: null,
      weiXinIdErr: '',
      mobile: null,
      mobileErr: '',
      radioValue: OPTIONS[0].value,
    });
  };

  renderDialog = () => {
    const { show = false, qqNumber, qqNumberErr } = this.state;
    return (
      <Dialog
        show={show}
        style={{ width: '480px' }}
        title="开户"
        onSubmit={this.fetchGdtOpen}
        onCancel={this.handleClose}
        onClose={this.handleClose}
        modalStyle={{ zIndex: 1050 }}
      >
        <FormGroup className={'required with-select'} error={qqNumberErr}>
          <label htmlFor={'qqNumber'}>QQ号：</label>
          <Input
            id={'qqNumber'}
            type={'number'}
            value={qqNumber}
            onChange={this.handleQQNumber}
          />
        </FormGroup>
      </Dialog>
    );
  };

  handleQQNumber = (e: object, qqNumber: string) => {
    this.setState({ qqNumber, qqNumberErr: '' });
  };

  handleWeiXinId = (e: object, weiXinId: string) => {
    this.setState({ weiXinId, weiXinIdErr: '' });
    // if (!weiXinId) {
    //   this.setState({ weiXinIdErr: '' });
    //   return;
    // }

    // if (this.timeout) {-
    //   clearTimeout(this.timeout);
    // }
    // // 校验微信号
    // this.timeout = (setTimeout(() => {
    //   checkNumber({
    //     wechat_number: weiXinId,
    //   }).then((res) => {
    //     this.setState({ weiXinIdErr: res.msg! });
    //   });
    // }, 500) as unknown) as number;
  };

  handleMobile = (e: object, mobile: string) => {
    const regex = /^\d{11}$/;
    const error = regex.test(mobile);
    this.setState({ mobile, mobileErr: error ?  '' : ' 请填写正确的手机号' });
  };

  validateNewParams = () => {
    if (this.state.radioValue === 'qqNumber') {
      if (!this.state.qqNumber) {
        this.setState({ qqNumberErr: errConfig.qqNumber.tip });
        return false;
      }

      if (!this.state.mobile) {
        this.setState({ mobileErr: errConfig.mobile.tip });
        return false;
      }

      this.setState({ mobileErr: '' });
      this.setState({ qqNumberErr: '' });
      return true;
    }

    if (this.state.radioValue === 'weiXinId') {
      // if (this.state.weiXinIdErr) {
      //   return false;
      // }

      if (!this.state.weiXinId) {
        this.setState({ weiXinIdErr: errConfig.weiXinId.tip });
        return false;
      }

      if (!this.state.mobile) {
        this.setState({ mobileErr: errConfig.mobile.tip });
        return false;
      }

      this.setState({ mobileErr: '' });
      this.setState({ weiXinIdErr: '' });
      return true;
    }
  };

  validateParams = () => {
    if (!this.state.qqNumber) {
      this.setState({ qqNumberErr: errConfig.qqNumber.tip });
      return false;
    }
    this.setState({ qqNumberErr: '' });
    return true;
  };

  changeRadioGroup = (value: string) => {
    this.setState({
      radioValue: value,
      qqNumber: null,
      weiXinId: null,
    });
  };

  renderNewDialog = () => {
    const {
      show = false,
      qqNumber,
      qqNumberErr,
      radioValue,
      weiXinId,
      weiXinIdErr,
      mobileErr,
      mobile,
    } = this.state;
    return (
      <Dialog
        show={show}
        style={{ width: '480px' }}
        title="开户"
        onSubmit={this.fetchNewGdtOpen}
        onCancel={this.handleNewClose}
        onClose={this.handleNewClose}
        modalStyle={{ zIndex: 1050 }}
      >
        <RadioGroup
          data={OPTIONS}
          value={radioValue}
          onChange={(_event, value) => this.changeRadioGroup(value)}
        />
        {radioValue === 'qqNumber' ? (
          <FormGroup className={'required with-select'} error={qqNumberErr}>
            <label htmlFor={'qqNumber'}>QQ号：</label>
            <Input
              id={'qqNumber'}
              type={'number'}
              value={qqNumber}
              onChange={this.handleQQNumber}
            />
          </FormGroup>
        ) : (
          <FormGroup className={'required with-select'} error={weiXinIdErr}>
            <label htmlFor={'weiXinId'}>微信号：</label>
            <Input
              id={'weiXinId'}
              value={weiXinId}
              onChange={this.handleWeiXinId}
            />
          </FormGroup>
        )}

        <FormGroup className={'required with-select'} error={mobileErr}>
          <label htmlFor={'mobile'}>手机号</label>
          <Input
            id={'mobile'}
            type={'number'}
            value={mobile}
            onChange={this.handleMobile}
          />
        </FormGroup>
      </Dialog>
    );
  };

  fetchNewGdtOpen = () => {
    if (this.disable || !this.validateNewParams()) return;
    // this.disable = true;
    const {
      webApi,
      lead: { leadId, agencyId },
      callback,
    } = this.props;
    const { qqNumber, radioValue, weiXinId, mobile } = this.state;
    const params = {
      leadId,
      agencyId,
      ...(radioValue === 'qqNumber' ? { qqNumber } : { weiXinId }),
      mobile,
    };
    webApi
      .gdtOpen()
      .ajaxJson({
        data: params,
      })
      .then((res: { code: number; message: string }) => {
        this.disable = false;
        if (res && res.code === 0) {
          callback && callback();
          message.success('成功');
          this.handleClose();
        } else {
          message.strongwarn(res?.message);
        }
      })
      .catch((err: { message: string }) => {
        this.disable = false;
        message.strongwarn(err?.message);
      });
  };

  fetchGdtOpen = () => {
    if (this.disable || !this.validateParams()) return;
    this.disable = true;
    const {
      webApi,
      lead: { leadId, agencyId },
      callback,
    } = this.props;
    const { qqNumber } = this.state;
    const params = {
      leadId,
      agencyId,
      qqNumber,
    };
    webApi
      .gdtOpen()
      .ajaxJson({
        data: params,
      })
      .then((res: { code: number; message: string }) => {
        this.disable = false;
        if (res && res.code === 0) {
          callback && callback();
          message.success('成功');
          this.handleClose();
        } else {
          message.strongwarn(res?.message);
        }
      })
      .catch((err: { message: string }) => {
        this.disable = false;
        message.strongwarn(err?.message);
      });
  };

  render() {
    return (
      <React.Fragment>
        {this.renderAccountId()}
        {this.props.supportWx ? this.renderNewDialog() : this.renderDialog()}
      </React.Fragment>
    );
  }
}
class AccountPanel extends React.PureComponent<
AccountPanelProps,
AccountPanelState
> {
  private accountDetail: React.RefObject<any>;
  constructor(props: AccountPanelProps) {
    super(props);
    this.state = {
      linkUrl: '',
    };
    this.accountDetail = React.createRef();
  }

  componentDidMount() {
    this.getLeadStatus();
  }

  getLeadStatus = () => {
    const {
      webApi,
      lead: { relatedLeadId },
    } = this.props;
    if (relatedLeadId) {
      webApi
        .getLeadStatus(relatedLeadId)
        .ajax()
        .then((res: { progressStatus: number }) => {
          if (res) {
            this.setState({
              linkUrl: leadStatusMap[res.progressStatus],
            });
          }
        })
        .catch((err: any) => {
          console.log(err);
        });
    }
  };

  linkToDetail = () => {
    const {
      lead: { relatedLeadId },
    } = this.props;
    const { linkUrl } = this.state;
    if (linkUrl && relatedLeadId) {
      window.location.href = `${window.location.origin}${REACT_APP_PUBLIC_URL}/${linkUrl}/${relatedLeadId}`;
    }
  };

  showAccountDetailModal = (tickedId: number) => {
    this.accountDetail.current.show({
      tickedId,
    });
  };

  /**
   * @description: 账户信息
   */
  renderAccountInfo = () => {
    const {
      lead: {
        intention,
        customerMpAppId,
        customerMpUserName,
        customerId,
        customerUnibdAppId,
        approvalStatus,
        gdtOpenCreatedTime,
        approvalTime,
        enterpriseName,
        auditMsg,
        customerMpUserNameTag,
        customerIndustryId,
      },
      account: { saleStatus },
      detail,
      registrationTicketId,
      isOrder,
      whiteList,
    } = this.props;
    const { agencyId, grayPermissions = [] } = saleStatus || {};
    const { adPlatformTypes } = intention || {};
    const {
      totalCost,
      firstChargeTime,
      firstChargeAmt,
      firstConsumeDate,
      isNewCustomer,
      newCustomerYearQuarter,
    } = detail;
    const accountId =      customerUnibdAppId || customerMpAppId || customerMpUserName || customerId;
    const customerIdViewData = {
      data: detail,
      customerData: {
        customerId,
        customerMpAppId,
        customerMpUserName,
        customerUnibdAppId,
      },
      callback: this.props.callback,
    };
    // 视频号tag
    const unispTag = customerMpUserNameTag ? `(${customerMpUserNameTag})` : '';
    return (
      <div className="account-info">
        <h2>账户信息</h2>
        <dl>
          <dt>账户 ID：</dt>
          <dd>
            {isOrder ? (
              <div>
                <span
                  style={{
                    marginRight: '5px',
                    color: accountId ? '#2096f5' : '#313233',
                  }}
                >
                  <CustomerIdView {...customerIdViewData} />
                </span>
                {(customerMpUserName || customerId || customerUnibdAppId)
                && registrationTicketId ? (
                  <span
                    onClick={(e) => {
                      this.showAccountDetailModal(registrationTicketId);
                    }}
                    style={{ color: 'gray', fontWeight: 16, cursor: 'pointer' }}
                  >
                    点击查看详情
                  </span>
                  ) : null}
              </div>
            ) : (
              <React.Fragment>
                {_.includes(whiteList.data, agencyId)
                && grayPermissions.indexOf(perms.GRAY_GDT_PROTECTION) > -1
                && ACCOUNT_STATUS[approvalStatus] !== ACCOUNT_STATUS['1'] ? (
                  <React.Fragment>
                    {customerId}
                    <OpenAccountModal {...this.props} />
                  </React.Fragment>
                  ) : (
                  <CustomerIdView {...customerIdViewData} />
                  )}
              </React.Fragment>
            )}
          </dd>
          <dt>广告主名称：</dt>
          <dd>{enterpriseName}</dd>
          <dt>APPID：</dt>
          <dd>
            {customerMpAppId && customerMpAppId.startsWith('unisp')
              ? `${customerMpAppId}${unispTag}`
              : customerMpAppId}
          </dd>
          <dt>微信原始ID：</dt>
          <dd>
            {customerMpUserName && customerMpUserName.startsWith('gh_')
              ? customerMpUserName
              : null}
          </dd>
          <dt>账户状态：</dt>
          <dd>
            {accountId ? (
              <span
                className={classNames({
                  'customer-pass': approvalStatus === 1,
                  'customer-reject': approvalStatus === 3,
                })}
              >
                {ACCOUNT_STATUS[approvalStatus]}{' '}
                {approvalStatus === 3 && auditMsg && `(${auditMsg})`}
              </span>
            ) : null}
          </dd>
          <dt>开户时间：</dt>
          <dd>
            <DateTime dateTime={gdtOpenCreatedTime} />
          </dd>
          <dt>账户审核通过时间：</dt>
          <dd>
            <DateTime dateTime={approvalTime} />
          </dd>
          <dt>实际首次充值时间：</dt>
          <dd>{firstChargeTime}</dd>
          <dt>实际首次充值金额：</dt>
          <dd>{rendeFirstChargeAmt(firstChargeAmt, ' ')}</dd>
          <dt>历史首次消耗时间：</dt>
          <dd>
            <DateTime date={firstConsumeDate} />
          </dd>
          <dt>开户行业：</dt>
          <dd>
            <IndustryInfo industryId={customerIndustryId} />
          </dd>
          {isOrder && (
            <>
              {/* <dt>累计消耗：</dt>
            <dd>{totalCost?.toFixed(2)}</dd> */}
              {grayPermissions.includes(perms.GRAY_CHECK_NEW_CUSTOM) && (
                <>
                  <dt>是否新客：</dt>
                  <dd>
                    {_.isBoolean(isNewCustomer) ? (
                      <div className="base-element-middle">
                        <TipIcon
                          value={`${isNewCustomer ? '是' : '否'}${
                            newCustomerYearQuarter
                              ? `-${newCustomerYearQuarter}`
                              : ''
                          }`}
                        >
                          <div>1.更新时间：每日更新昨日最新状态；</div>
                          <div>2.新客表示同主体上个季度无消耗。</div>
                        </TipIcon>
                      </div>
                    ) : (
                      ''
                    )}
                  </dd>
                </>
              )}
            </>
          )}
        </dl>
      </div>
    );
  };

  render() {
    return (
      <div className="CustomerPanel">
        {this.renderAccountInfo()}
        <Delegate ref={this.accountDetail} component={AccountDetail} />
      </div>
    );
  }
}
function mapStateToProps(state: { customerProtectionWhiteList: WhiteList }) {
  return {
    whiteList: state.customerProtectionWhiteList,
  };
}

export default withApi(withAccount(connect(mapStateToProps, {})(AccountPanel)));
